import { AbstractControl, ValidationErrors } from "@angular/forms";

export function letterValidator(control: AbstractControl): ValidationErrors| null {

  if(control && (control.value !== null || control.value !== undefined)){
    const validate = /[A-Za-z]/.test(control.value);

    if (!validate){
      return {
        'letterValidator' : true
      };
    }
  }

  return null;
}
